import { render, staticRenderFns } from "./IS-results.vue?vue&type=template&id=bf0cfc4e"
import script from "./IS-results.vue?vue&type=script&lang=js"
export * from "./IS-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports